import { getPageContext } from './context';

// Copy identity and readiness only. Customer records never enter the panel's draft state.
export function getStaffPageContext({ pathname, search, store, guards = {} }) {
  const offerStore = store.offer;
  const account = store.account;
  const policyStore = account.policies.policy;
  const isOffer = /^\/offer\/[^/]+\/?$/.test(pathname);
  const isPolicy = /^\/customer\/[^/]+\/policy\//.test(pathname);
  const pageKey = pathname + search;
  const registered = Reflect.ownKeys(guards).map((key) => guards[key]);
  const offerGuard = registered.find(
    (guard) => guard.kind === 'offer' && guard.pageKey === pageKey && guard.recordId === offerStore.offer?.id
  );
  const accountDirty = registered.some(
    (guard) => guard.kind === 'account' && guard.recordId === account.id && guard.pageKey === pageKey && guard.dirty
  );
  const loading = isOffer
    ? offerStore.loading || !offerGuard
    : account.accountLoading || (isPolicy && (policyStore.loading || policyStore.revertLoading));
  const failed = isOffer ? !!offerStore.errors?.length : !!account.errors?.length;
  const dirty = accountDirty || (isOffer ? offerGuard?.dirty : isPolicy && policyStore.changed);
  const preview = isPolicy && (policyStore.preview || policyStore.revertPreview || policyStore.isPreviewExpired);
  let status = 'ready';
  if (failed) {
    status = 'error';
  } else if (loading) {
    status = 'loading';
  }
  return getPageContext(pathname, {
    status,
    view: dirty ? 'dirty' : 'current',
    search,
    previewId: preview ? 'active-preview' : undefined,
    offer: { id: offerStore.offer?.id },
    account: { id: account.id },
    policy: { id: policyStore.policy?.id }
  });
}
